import gsap from 'gsap'

import { useRouterStore } from '@/store/router'

import {
  fadeRevealAnimation,
  linesRevealAnimation,
  mediaZoomRevealAnimation,
  opacityRevealAnimation,
  paragraphRevealAnimation
} from './shared'

let heroTimeline: GSAPTimeline | null = null

export const heroCoverRevealAnimation = (
  node: HTMLElement,
  active: boolean,
  done?: () => void
) => {
  // Il nodo in uscita viene smontato subito dopo il fade (unmountOnExit),
  // quindi niente revert() dello split-text qui: lo ripristinerebbe mentre
  // la slide è ancora a piena opacità, causando un saltino visibile.
  heroTimeline?.kill()

  const selector = gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const subtitle = selector('[data-motion-subtitle]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]
  const text = selector('[data-motion-text]')[0]
  const cta = selector('[data-motion-cta]')[0]
  const label = selector('[data-motion-label]')[0]
  const breadcrumbs = selector('[data-motion-breadcrumbs]')[0]

  const isLanding = useRouterStore.getState().previousRoute === undefined

  heroTimeline = gsap.timeline({ onComplete: done, delay: isLanding ? 0.5 : 0 })

  if (!active) {
    heroTimeline.add(
      gsap.to(node.children, { opacity: 0, duration: 0.3, ease: 'power3.out' }),
      '<'
    )
  } else {
    heroTimeline.set(node, { opacity: 1 }).set(node.children, { opacity: 1 })

    if (media) {
      heroTimeline.add(mediaZoomRevealAnimation(media).timeline, 0)
    }

    if (pretitle) {
      heroTimeline.add(fadeRevealAnimation(pretitle).timeline, 0.2)
    }

    if (title) {
      heroTimeline.add(linesRevealAnimation(title, true).timeline, 0.2)
    }

    if (subtitle) {
      heroTimeline.add(paragraphRevealAnimation(subtitle, true).timeline, 0.3)
    }

    if (text) {
      heroTimeline.add(paragraphRevealAnimation(text, true).timeline, 0.4)
    }

    if (paragraph) {
      heroTimeline.add(fadeRevealAnimation(paragraph).timeline, 0.5)
    }

    if (cta) {
      heroTimeline.add(fadeRevealAnimation(cta).timeline, 0.5)
    }

    if (label) {
      heroTimeline.add(fadeRevealAnimation(label).timeline, 0.5)
    }

    if (breadcrumbs) {
      heroTimeline.add(opacityRevealAnimation(breadcrumbs).timeline, 0.5)
    }
  }
}
